const tokenKey = 'project.auth.token';
export const readToken = () => localStorage.getItem(tokenKey) || sessionStorage.getItem(tokenKey);
export function clearToken() {
  localStorage.removeItem(tokenKey);
  sessionStorage.removeItem(tokenKey);
}
export function saveToken(token, remember) {
  clearToken();
  (remember ? localStorage : sessionStorage).setItem(tokenKey, token);
}

export async function request(path, options = {}) {
  const token = readToken();
  const response = await fetch(`/api/Authenticate${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    signal: options.signal || AbortSignal.timeout(15000),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const error = new Error(body.message || (response.status === 429
      ? 'Demasiados intentos. Esperá un minuto y volvé a intentar.'
      : 'No se pudo completar la operación. Intentá nuevamente.'));
    error.status = response.status;
    if (response.status === 401) {
      clearToken();
      window.dispatchEvent(new Event('auth:expired'));
    }
    throw error;
  }
  return response.status === 204 ? null : response.json();
}
